import { FormProvider } from 'react-hook-form';
import { useShippingAddressEditForm } from './hooks';
import { convertToPresentationProps } from './logics/convertToPresentationProps';
import { ShippingAddressEditFormPresentation } from './presentations';

type Props = {
  /** 企業コード */
  threeLetterCode: string;
  /** キャンセルボタン押下時のコールバック（呼び出し側で確認ビューに戻す） */
  onCancel: () => void;
  /** 保存成功時のコールバック（呼び出し側で確認ビューに戻す） */
  onSaved: () => void;
};

/**
 * 送付先住所編集フォーム
 *
 * 確認ダイアログの内側で「内容を修正」から表示する。クライアント情報と都道府県一覧を
 * suspense 前提で取得するため、呼び出し側の Suspense 境界の内側で描画すること。
 */
export const ShippingAddressEditForm: React.FC<Props> = ({
  threeLetterCode,
  onCancel,
  onSaved,
}) => {
  const {
    state: { methods, prefecturesData, isSaving },
    actions: { handleSubmit },
  } = useShippingAddressEditForm({ threeLetterCode, onSaved });

  const { prefectureOptions } = convertToPresentationProps({ prefecturesData });

  return (
    <FormProvider {...methods}>
      <ShippingAddressEditFormPresentation
        prefectureOptions={prefectureOptions}
        isSaving={isSaving}
        onCancel={onCancel}
        onSubmit={handleSubmit}
      />
    </FormProvider>
  );
};
